import { render, staticRenderFns } from "./tipDialog.vue?vue&type=template&id=745aba08&scoped=true"
import script from "./tipDialog.vue?vue&type=script&lang=js"
export * from "./tipDialog.vue?vue&type=script&lang=js"
import style0 from "./tipDialog.vue?vue&type=style&index=0&id=745aba08&prod&lang=scss"
import style1 from "./tipDialog.vue?vue&type=style&index=1&id=745aba08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745aba08",
  null
  
)

export default component.exports